module.exports = __webpack_public_path__ + "cf49c8fe086b02aad00597534658f286.pdf";